(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('incidentCoordinationFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$log', '$location', '$routeParams', '$filter', '$anchorScroll', '$timeout', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $log, $location, $routeParams, $filter, $anchorScroll, $timeout, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('documentController', { $scope: $scope });
                $controller('caseNotesHistoryController', { $scope: $scope });
                $controller('feedbackAssignmentHistoryController', { $scope: $scope });

                // Default access for attaching documents
                DataServices.responseInfo.access = {
                    canSaveFile: true,
                    canViewFile: true,
                    canDeleteFile: true
                };

                // This form is always editable, access around the other aspects on the page is governed by other conditions
                $scope.isPageEditable = true;
                $scope.discardCancelVerification  = false;

                var riskAssessmentCode = 'riskassessment';
                var notificationCode = 'notification';
                var investigationCode = 'investigation';
                var practiceImprovementCode = 'practiceimprovement';

                $scope.configData = null;
                $scope.isLoading = true;
                $scope.access = DataServices.responseInfo.access;

                $scope.coordinationTemplate = Constants.ConfigTemplate.incidentCoordination;
                // Set original response to current response as update has occurred.
                $scope.originalResponse = angular.copy($scope.responses);

                // Gets the followup summary details for each of the three possible followups for this incident.
                var getFollowUpSummary = function () {
                    DataServices.getFollowUpSummaryResponseAndConfig(Constants.FeedbackType.Privacy, $scope.coordinationTemplate)
                        .then(function (response) {
                            $scope.isLoading = false;
                            var data = response.data;
                            if (data) {
                                DataServices.configData = data.configData.configData;
                                DataServices.responseInfo.template = data.template;
                                DataServices.responseInfo.versionNumber = null; // reset version number to null.
                                DataServices.responseInfo.followUpVersionNumber = data.versionNo; // followup version number gets set here for subsequent pages (investigation, Notification, RA, PI)
                                DataServices.responseInfo.role = data.role;
                                DataServices.responseInfo.responses = data.responseData;
                                DataServices.responseInfo.feedbackId = data.feedbackId;
                                DataServices.responseInfo.ref = data.ref;
                                DataServices.responseInfo.feedbackCaseNotes = data.feedbackCaseNotes;

                                DataServices.responseInfo.incidentRef = data.ref;
                                DataServices.responseInfo.statusText = data.statusDisplayName;

                                $scope.configData = DataServices.configData;
                                $scope.feedbackId = DataServices.responseInfo.feedbackId;
                                $scope.isFeedbackComplete = (data.statusId === Constants.Status.Withdrawn || data.statusId === Constants.Status.Closed); 
                                $scope.ref = DataServices.responseInfo.ref;
                                $scope.template = DataServices.responseInfo.template;
                                $scope.versionNumber = null; // reset version number to null.
                                $scope.followUpVersionNumber = data.versionNo;
                                $scope.role = DataServices.responseInfo.role;

                                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                                $scope.statusText = DataServices.responseInfo.statusText;

                                // Specify file access
                                DataServices.responseInfo.access.canSaveFile = !$scope.isFeedbackComplete || data.statusId === Constants.Status.Closed;
                                DataServices.responseInfo.access.canDeleteFile = !$scope.isFeedbackComplete ;

                                data.feedbackDocuments.forEach(function (doc) {
                                    var uploadedDoc = {
                                        documentId: doc.id,
                                        name: doc.name,
                                        incidentId: DataServices.responseInfo.feedbackId,
                                        isDeleteDisabled: !doc.canDeleteFile,
                                        isDocUploaded: true,
                                        size: doc.size,
                                        uploadDateTime: new Date(doc.createdTime).toLocaleString('en-AU', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
                                    };
                                    $scope.responses.documents.push(uploadedDoc);
                                });

                                DataServices.responseInfo.responses.documents = $scope.responses.documents;
                                if ($scope.responses.documents.length > 0) {
                                    $scope.initPageAttachments();
                                }

                                $scope.responses = data.responseData;

                                $scope.getHistory();
                                $scope.getFeedbackAssignmentHistory();
                                $scope.setupTriggersAndDynamicValues();
                                document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                            }
                            else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        });
                }

                $scope.addFollowUpAction = function (sectionCode, buttonText) {

                    // Do nothing if the feedback is already in a final state
                    if ($scope.isFeedbackComplete) {
                        return;
                    }

                    var template;
                    var nextPage;

                    switch (sectionCode) {
                        case riskAssessmentCode:
                            template = Constants.ConfigTemplate.riskAssessment;
                            nextPage = Constants.Url.firstRiskAssessmentFormPage;
                            $scope.isLoadingRiskAssessment = true;
                            break;

                        case notificationCode:
                            template = Constants.ConfigTemplate.notification;
                            nextPage = Constants.Url.firstNotificationFormPage;
                            $scope.isLoadingNotification = true;
                            break;

                        case investigationCode:
                            template = Constants.ConfigTemplate.investigation;
                            nextPage = Constants.Url.firstInvestigationFormPage;
                            $scope.isLoadingInvestigation = true;
                            break;

                        case practiceImprovementCode:
                            template = Constants.ConfigTemplate.practiceImprovement;
                            nextPage = Constants.Url.firstPracticeImprovementFormPage;
                            $scope.isLoadingPracticeImprovement = true;
                            break;
                    }

                    DataServices.isFollowUpEditable = true;

                    DataServices.getConfigurationUsingCache(template, null, $scope.feedbackId, DataServices.isAuthenticated())
                        .then(function (data) {

                            $scope.isLoadingRiskAssessment = false;
                            $scope.isLoadingNotification = false;
                            $scope.isLoadingInvestigation = false;
                            $scope.isLoadingPracticeImprovement = false;

                            if (data) {
                                DataServices.responseInfo.followUpId = null; // reset followup id for add.
                                DataServices.responseInfo.template = data.template
                                DataServices.responseInfo.versionNumber = data.versionNumber;
                                DataServices.responseInfo.role = data.role;
                                DataServices.responseInfo.responses = {};
                                DataServices.responseInfo.spStatus = Constants.FollowUpStatus.draft;
                                DataServices.responseInfo.spStatusText = 'Draft'; // default for new.
                                DataServices.responseInfo.frStatus = 0; // reset
                                DataServices.responseInfo.frStatusText = ''; // reset
                                DataServices.responseInfo.incidentFRStatus = 0; // reset
                                DataServices.validationErrors = [];
                                DataServices.configData = data.configData;
                                $scope.configData = DataServices.configData;
                                DataServices.pushConfigData(data.configData, template, data.versionNumber, data.role);

                                DataServices.trackEventsWithGA('PageName: Incident Coordination', 'Click ' + buttonText, buttonText);
                                $location.path(nextPage);
                            } else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        }, function (data) {
                            $scope.utility.showNotification(true, 'internalError');
                        });
                }

                // Opens an existing followup action for Edit / View
                $scope.openFollowUpAction = function (template, followUpId) {
                    if (template == 3) {
                        $scope.isLoadingRiskAssessment = true;
                    }
                    else if (template == 4) {
                        $scope.isLoadingNotification = true;
                    }
                    else if (template == 5) {
                        $scope.isLoadingInvestigation = true;
                    }
                    else if (template == 6) {
                        $scope.isLoadingPracticeImprovement = true;
                    }

                    DataServices.getFollowUpResponseAndConfig(followUpId, Constants.FeedbackType.Privacy)
                        .then(function (response) {
                            if (template == 3) {
                                $scope.isLoadingRiskAssessment = false;
                            }
                            else if (template == 4) {
                                $scope.isLoadingNotification = false;
                            }
                            else if (template == 5) {
                                $scope.isLoadingInvestigation = false;
                            }
                            else if (template == 6) {
                                $scope.isLoadingPracticeImprovement = false;
                            }

                            var data = response.data;
                            if (data) {

                                DataServices.responseInfo.access = data.access;

                                DataServices.responseInfo.status = data.statusId;

                                DataServices.responseInfo.incidentRef = data.ref;
                                DataServices.responseInfo.statusText = data.statusDisplayName;

                                DataServices.responseInfo.followUpId = followUpId;
                                DataServices.responseInfo.template = data.template
                                DataServices.responseInfo.versionNumber = data.versionNo;
                                DataServices.responseInfo.role = data.role;
                                DataServices.responseInfo.lastUpdatedTime = data.lastUpdatedTime;
                                DataServices.validationErrors = [];
                                DataServices.configData = data.configData.configData;
                                $scope.configData = DataServices.configData;
                                DataServices.pushConfigData(data.configData.configData, template, data.versionNo, data.role);

                                DataServices.isFollowUpEditable = (data.statusId !== Constants.FollowUpStatus.submitted && $scope.isFeedbackComplete === false);

                                DataServices.responseInfo.responses = data.responseData;
                                $scope.responses = DataServices.responseInfo.responses;

                                switch (template) {
                                    case Constants.ConfigTemplate.riskAssessment:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Risk Assessment', 'Edit/View Risk Assessment');
                                        $location.path(Constants.Url.firstRiskAssessmentFormPage);
                                        break;
                                    case Constants.ConfigTemplate.notification:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Notification', 'Edit/View Notification');
                                        $location.path(Constants.Url.firstNotificationFormPage);
                                        break;
                                    case Constants.ConfigTemplate.investigation:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Investigation', 'Edit/View Investigation');
                                        $location.path(Constants.Url.firstInvestigationFormPage);
                                        break;
                                    case Constants.ConfigTemplate.practiceImprovement:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Practice Improvement', 'Edit/View Practice Improvement');
                                        $location.path(Constants.Url.firstPracticeImprovementFormPage);
                                        break;
                                }
                            } else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        });
                }

                $scope.saveAndReturnToLanding = function () {
                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                        // Case Note is not mandatory, and therefore we need to ignore when they submit an empty text field 
                        if (!$scope.notEmpty(null, 'cCaseNotes', 'casenotes', 0, 0, '1-1')) {
                            $scope.returnToPrivacy();
                        }
                        else {
                            $scope.isSaving = true;
                            $scope.saveFeedbackCaseNotes().then(function () {
                                $location.path(Constants.Url.manageFeedbacks);
                            });
                         
                        }
                    }
                    else {
                        $scope.alertFirstError();
                    }
                }

                $scope.saveFeedbackCaseNotes = function () {
                    return DataServices.saveFeedbackCaseNotes()
                                                 .then(function (response) {
                                                     if (response.data) {
                                                         if (response.data.status === 3) {

                                                             DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save Feedback Case Notes And Documents', 'Successfully Saved Feedback Case Notes And Documents');
                                                             $scope.originalResponse = angular.copy($scope.responses);
                                                             $scope.discardCancelVerification = true;
                                                             return $scope.utility.openPopup('submissionSuccessMessage').result;
                                                         } else {
                                                             DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl, 'Click  Save Feedback Case Notes And Documents', 'Failed to  Save Feedback Case Notes And Documents');
                                                             return $scope.utility.openPopup('submissionFailureMessage').result;
                                                         }
                                                     }
                                                     else {
                                       			        return $scope.utility.showNotification(true, 'internalError', null, true);
                                                     }
                                                 }, function (response) {
                                                     DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl, 'Click  Save Feedback Case Notes And Documents', 'Failed to  Save Feedback Case Notes And Documents');
                                                     return $scope.utility.openPopup('submissionFailureMessage').result;
                                                 })
                                                 .finally(function () {
                                                     $scope.isSaving = false;
                                                 });
                }


                

                $scope.checkValueChangeForCoordinationPage = function () {
                    if ($scope.discardCancelVerification ) {
                        return false;
                    }

                    return $scope.notEmpty(null, 'cCaseNotes', 'casenotes', 0, 0, '1-1');
                }

                $scope.returnToPrivacy = function () {

                    if (!$scope.notEmpty(null, 'cCaseNotes', 'casenotes', 0, 0, '1-1')) {
                        $location.path(Constants.Url.manageFeedbacks);
                    } else {
                        $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                                                  function (data) {
                                                    if (data.result == "thirdButtonClick") {
                                                        $scope.saveFeedbackCaseNotes().then(function () {
                                                            $location.path(Constants.Url.manageFeedbacks);
                                                        });
                                                    }
                                                    else {
                                                        $scope.discardCancelVerification = true;
                                                        $location.path(Constants.Url.manageFeedbacks);
                                                    }
                                                  });
                    }
                }

                $scope.callCancelFollowUp = function () {
                    $scope.returnToPrivacy();
                }

                getFollowUpSummary();
            }]);
}());